import { CommonModule } from '@angular/common';
import { Component, Input} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControlPipe } from '@app/utils/form-control.pipe';


@Component({
  selector: 'so-textarea',
  templateUrl: './so-textarea.component.html',
  styleUrls: ['./so-textarea.component.css'],
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,    
    MatTooltipModule,
    ReactiveFormsModule,
    FormControlPipe
  ]
})
export class SoTextareaComponent {
  @Input() formCtrl: FormControl;
  @Input() placeHolder  = "Please enter text.";
  @Input() disableClearBtn = false;
  @Input() errormessage= "Entry is invalid.";
  @Input() label = "Label not set.";
  @Input() rows = 3;
  @Input() readOnlyInd = false;
  @Input() toolTip = "";


  clearControl() {
    this.formCtrl.setValue(""); 
  }
 
}
